import styled from "styled-components";

export const Card = styled.div`
  background: rgba(241, 245, 249, 0.45);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 24px;
  padding: clamp(1.25rem, 2vw, 1.75rem) clamp(1.25rem, 2.5vw, 2rem);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45);
`;

export const Surface = styled(Card)`
  background: rgba(255, 255, 255, 0.92);
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.25);
`;

export const PrimaryButton = styled.button`
  --btn-bg: linear-gradient(135deg, #38bdf8, #6366f1);
  border: none;
  border-radius: 999px;
  padding: 0.65rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
  background-image: var(--btn-bg);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 20px 30px rgba(79, 70, 229, 0.25);
    filter: brightness(1.03);
  }

  &:disabled {
    cursor: not-allowed;
    background-image: none;
    background-color: rgba(148, 163, 184, 0.45);
    color: rgba(15, 23, 42, 0.45);
    box-shadow: none;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background-image: none;
  background-color: rgba(148, 163, 184, 0.2);
  color: #111827;
  border: 1px solid rgba(148, 163, 184, 0.4);

  &:hover:not(:disabled) {
    box-shadow: none;
    background-color: rgba(148, 163, 184, 0.3);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  resize: vertical;
  padding: 1rem 1.1rem;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  font-size: 0.95rem;
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  background: rgba(15, 23, 42, 0.02);
  color: #0f172a;
  line-height: 1.6;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: rgba(99, 102, 241, 0.85);
    box-shadow: 0 0 0 4px rgba(129, 140, 248, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Label = styled.label`
  display: block;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.65rem;
  letter-spacing: 0.01em;
`;

export const HelperText = styled.p`
  font-size: 0.9rem;
  color: #475569;
  margin-top: 0.6rem;
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
`;

export const Muted = styled.p`
  font-size: 0.95rem;
  color: #475569;
  margin: 0;
`;

export const JsonBlock = styled.pre`
  width: 100%;
  background: #0f172a;
  color: #e2e8f0;
  padding: 1.25rem;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  overflow-x: auto;
  font-size: 0.85rem;
  line-height: 1.6;
  max-height: 420px;
`;

export const InlineCode = styled.code`
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  background: rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  padding: 0.15rem 0.35rem;
  font-size: 0.85rem;
`;

export const List = styled.ul`
  padding-left: 1.15rem;
  margin: 0.75rem 0 0;
  color: #334155;
  line-height: 1.75;
`;

export const ListItem = styled.li`
  margin-bottom: 0.35rem;
`;

export const EmptyState = styled.div`
  padding: 2.5rem 1.75rem;
  border: 1px dashed rgba(148, 163, 184, 0.45);
  border-radius: 20px;
  text-align: center;
  color: #475569;
`;
